(() => {
  const init = (root = document) => {
    root.querySelectorAll('.wellness-menu:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const nav = document.getElementById(button.getAttribute('aria-controls'));
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        nav?.classList.toggle('is-open', open);
      });
    });
    root.querySelectorAll('#nutrition-period:not([data-ready])').forEach(select => {
      select.dataset.ready = 'true';
      for(const option of select.options){const total=Number(option.dataset.price);if(Number.isFinite(total)){option.textContent=option.dataset.days+'-day £ · '+total.toFixed(2)+' total';option.dataset.daily='£'+(total/Number(option.dataset.days)).toFixed(2)+'/'+(option.dataset.days==='60'?'day':'Day');}}
      const update = () => {
        const p = select.selectedOptions[0].dataset;
        const panel = select.closest('.nutrition-option-panel');
        panel.querySelector('.nutrition-choice-summary h3').textContent = p.title;
        panel.querySelector('.nutrition-daily strong').textContent = p.daily;
        panel.querySelector('.nutrition-choice-summary > p:last-child').textContent = p.included;
        panel.querySelector('[data-nutrition-cta]').href = p.quiz;
        panel.querySelector('[data-nutrition-details]').href = p.details;
      };
      select.addEventListener('change', update);update();
    });
    root.querySelectorAll('video[data-src]:not([data-ready])').forEach(video => {
      video.dataset.ready = 'true';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      const sync = () => {
        if (visible && !reduce.matches && !document.hidden) {
          if (!video.getAttribute('src')) video.src = video.dataset.src;
          video.play().catch(() => {});
        } else video.pause();
      };
      const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();},{threshold:.25});
      observer.observe(video);reduce.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);
    });
    root.querySelectorAll('#wellness-contact:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';form.addEventListener('submit',e=>{
        e.preventDefault();const d=new FormData(form);
        location.href='mailto:info@elzhanabn.com?subject='+encodeURIComponent(d.get('topic'))+'&body='+encodeURIComponent('Hi Elzhana,\n\n'+d.get('message')+'\n\n'+d.get('name'));
      });
    });
    const finder=root.querySelector('[data-finder-result]');
    if(finder && !finder.dataset.ready){
      finder.dataset.ready='true';
      const box=finder.closest('.finder-layout');
      const update=()=>{
        const goal=box.querySelector('[name="goal"]:checked').value;
        const days=box.querySelector('[name="duration"]').value;
        box.querySelector('[data-finder-duration]').hidden=goal!=='personalised';
        const slug=goal==='movement'?'free-home-workout-plan':goal==='inspiration'?'7-day-meal-plan':days+'-day-personalised-'+(days==='30'?'nutrition':'nutrition')+'-plan';
        const p=window.wellnessProducts?.find(p=>p.slug===slug);
        if(!p)return;
        finder.querySelector('h2').textContent=p.title;
        finder.querySelector('.finder-price').textContent=p.price;
        const paras=finder.querySelectorAll(':scope > p');paras[2].textContent=p.intro;paras[3].textContent=p.included;
        finder.querySelector('.wellness-button').href='/products/'+p.storeHandle;
      };
      box.addEventListener('change',update);update();
    }
  };
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
